import typography from "./typography";

const CLASS_MAP = {
  [typography.TOTAL_USERS_ALL_TIME]: "primary-gradient-bg",
  [typography.PAID_USERS]: "bg-orange",
  [typography.FREE_USERS]: "bg-blue",
  [typography.ENGAGED_USERS]: "primary-gradient-bg",
  [typography.DELETED_USERS]: "bg-orange",
  [typography.IDLE_USERS]: "bg-blue",
  [typography.SIGNUPS]: "bg-purple",
};

export const findOutClassStatBoxes = (value) => CLASS_MAP[value] ?? "";
